// PASTE #377 + #468 relabel: CLIENT-FACING box-size names. Alexis's #468
// directive: shoppers see a plain word - Small / Standard / Large (Standard =
// QB, the default + best value) - with the box code (EB/QB/HB) shown small
// beside it, so the language stays congruent with packing, compras emails, and
// invoices while reading plainly. The STORED value is always the box CODE
// (EB/QB/HB); these are display labels only. INTERNAL / ops surfaces (admin,
// compras email, invoice memo, order display) keep the raw codes and do NOT use
// these helpers. Pure/display-only.

// The spelled label used in the cart-box title + the catalog bar's desktop fill
// label ("Box 1 · standard box").
export function spelledBoxSize(size: string): string {
  switch (size) {
    case "EB":
      return "small box";
    case "QB":
      return "standard box";
    case "HB":
      return "large box";
    case "FB":
      return "full box";
    default:
      return size;
  }
}

// The one-word capitalized size for the small pill chips + the mobile fill
// label - "Small" / "Standard" / "Large" / "Full".
export function sizeWord(size: string): string {
  switch (size) {
    case "EB":
      return "Small";
    case "QB":
      return "Standard";
    case "HB":
      return "Large";
    case "FB":
      return "Full";
    default:
      return size;
  }
}
